<template>
  <div class="cost">
    <div class="form-container">
      <el-form :model="ruleForm" ref="ruleForm" label-width="80px">
        <el-form-item label="时间：" prop="date">
          <el-date-picker
            v-model="ruleForm.date"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <div class="flex">
          <el-form-item label="A：">
            <el-input class="white" v-model="ruleForm.A"></el-input>
          </el-form-item>
          <el-form-item label="a：">
            <el-input class="white" v-model="ruleForm.a"></el-input>
          </el-form-item>
          <el-form-item label="b：">
            <el-input class="white" v-model="ruleForm.b"></el-input>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label>
            <el-button class="btn-blue" @click="calculate">计算</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="result">
      <p>sku数量：{{ skuQuantity }}</p>
      <p>商品数量：{{ goodsQuantity }}</p>
      <p>订单数量：{{ orderNum }}</p>
      <p>成本：{{ total }}</p>
    </div>
  </div>
</template>

<script>
import Cost from "models/cost";
const cost = new Cost();
export default {
  data() {
    return {
      ruleForm: {
        date: "",
        A: "",
        a: "",
        b: ""
      },
      skuQuantity: "",
      total: "",
      goodsQuantity: "",
      orderNum: ""
    };
  },
  methods: {
    calculate() {
      let startTime;
      let endTime;
      if (this.ruleForm.date) {
        startTime = this.ruleForm.date[0];
        endTime = this.ruleForm.date[1];
      } else {
        this.$message.error("请选择日期");
        return false;
      }
      let A = this.ruleForm.A;
      let a = this.ruleForm.a;
      let b = this.ruleForm.b;
      cost
        .getCostPrice(startTime, endTime, A, a, b)
        .then(res => {
          if (res.success) {
            if (res.result) {
              this.skuQuantity = res.result.skuQuantity
                ? res.result.skuQuantity
                : 0;
              this.total = res.result.total ? res.result.total : 0;
              this.goodsQuantity = res.result.goodsQuantity
                ? res.result.goodsQuantity
                : 0;
              this.orderNum = res.result.orderNum ? res.result.orderNum : 0;
            } else {
              this.skuQuantity = 0;
              this.total = 0;
              this.goodsQuantity = 0;
              this.orderNum = 0;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("计算失败");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.cost {
  flex: 1;
  .form-container {
    padding: 16px;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    padding-bottom: 0;
    .flex {
      display: flex;
    }
  }
  .result {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    padding-left: 80px;
    p {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>
